module.exports = __webpack_public_path__ + "static/img/honor.7448e4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/honor.png
// module id = 8ZXw
// module chunks = 1